export const getReduxForms = (state) => state.form;
export const getBasename = (state) => state.app.basename;
export const getHub = (state) => state.app.hub;
